import { render, staticRenderFns } from "./BatchAddOnSale.vue?vue&type=template&id=71201d8e&scoped=true"
import script from "./BatchAddOnSale.vue?vue&type=script&lang=js"
export * from "./BatchAddOnSale.vue?vue&type=script&lang=js"
import style0 from "./BatchAddOnSale.vue?vue&type=style&index=0&id=71201d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71201d8e",
  null
  
)

export default component.exports